module.exports = __webpack_public_path__ + "img/img-97c1df.png";